import { useState, useEffect } from "react";
import withLoader from "../../../components/layouts/WithLoader"
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import BankService from "../../../services/PosService/BankService";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import UtilsFormule from "../../../utils/UtilsFormule";
import { TextField } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import PrintableK from "../PrintableK";
import nombreEnTexte from "../../../utils/NombreEnTexte";
import BanqueService from "../../../services/Banque";
const styles = {
    container: (base) => ({
        ...base,
        flex: 1,
    }),
};
const ChargerWalletMultiCheque = ({ startLoading, stopLoading }) => {
    const animatedComponents = makeAnimated();

    const navigate = useNavigate();

    const [datePayementCheque, setDatePayementCheque] = useState("");
    const [codePayementCheque, setCodePayementCheque] = useState("");
    const [emetteurCheque, setEmetteurCheque] = useState("");

    // Parametres de génération
    // const [nbCheques, setNbCheques] = useState("");
    // const [dateDebut, setDateDebut] = useState("");
    // const [periodicite, setPeriodicite] = useState("30"); // jours

    // const PERIODICITES = [
    //     { value: "7",   label: "1 fois par semaine (7 jours)" },
    //     { value: "14",  label: "1 fois par 2 semaines (14 jours)" },
    //     { value: "30",  label: "1 fois par mois (30 jours)" },
    //     { value: "60",  label: "1 fois par 2 mois (60 jours)" },
    //     { value: "90",  label: "1 fois par trimestre (90 jours)" },
    // ];

    // const generateChequeLines = () => {
    //     if (!nbCheques || !dateDebut || !periodicite) return;
    //     const n = parseInt(nbCheques);
    //     if (isNaN(n) || n <= 0) return;
    //     const base = new Date(dateDebut);
    //     const lines = Array.from({ length: n }, (_, i) => {
    //         const d = new Date(base);
    //         d.setDate(d.getDate() + i * parseInt(periodicite));
    //         const pad = (v) => String(v).padStart(2, "0");
    //         const dateStr = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00`;
    //         return { dateEcheance: dateStr, refCheque: "" };
    //     });
    //     setChequeLines(lines);
    //     if (lines.length > 0) {
    //         setDatePayementCheque(lines[0].dateEcheance.concat(":59"));
    //         setCodePayementCheque("");
    //     }
    // };

      // Parametres de génération
    const [nbCheques, setNbCheques] = useState("");
    const [dateDebut, setDateDebut] = useState("");
    const [periodicite, setPeriodicite] = useState("30");

    const PERIODICITES = [
        { value: "7",  label: "1 fois par semaine (7 jours)" },
        { value: "14", label: "1 fois par 2 semaines (14 jours)" },
        { value: "30", label: "1 fois par mois (30 jours)" },
        { value: "60", label: "1 fois par 2 mois (60 jours)" },
        { value: "90", label: "1 fois par trimestre (90 jours)" },
    ];

    const generateChequeLines = () => {
        if (!nbCheques || !dateDebut || !periodicite) return;
        const n = parseInt(nbCheques);
        if (isNaN(n) || n <= 0) return;
        const base = new Date(dateDebut);
        const pad = (v) => String(v).padStart(2, "0");
        const lines = Array.from({ length: n }, (_, i) => {
            const d = new Date(base);
            d.setDate(d.getDate() + i * parseInt(periodicite));
            const dateStr = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00`;
            return { dateEcheance: dateStr, refCheque: "" };
        });
        setChequeLines(lines);
        if (lines.length > 0) {
            setDatePayementCheque(lines[0].dateEcheance.concat(":59"));
            setCodePayementCheque("");
        }
    };

    // Tableau de lignes chèques: [{dateEcheance, refCheque}]
    const [chequeLines, setChequeLines] = useState([{ dateEcheance: "", refCheque: "" }]);

    const addChequeLine = () => {
        setChequeLines(prev => [...prev, { dateEcheance: "", refCheque: "" }]);
    };

    const removeChequeLine = (index) => {
        setChequeLines(prev => {
            const updated = prev.filter((_, i) => i !== index);
            const result = updated.length > 0 ? updated : [{ dateEcheance: "", refCheque: "" }];
            if (result.length > 0) {
                setDatePayementCheque(result[0].dateEcheance ? result[0].dateEcheance.concat(":59") : "");
                setCodePayementCheque(result[0].refCheque);
            }
            return result;
        });
    };

    const updateChequeLine = (index, field, value) => {
        setChequeLines(prev => {
            const updated = prev.map((line, i) =>
                i === index ? { ...line, [field]: value } : line
            );
            if (index === 0) {
                if (field === "dateEcheance") {
                    setDatePayementCheque(value ? value.concat(":59") : "");
                    setData(d => ({ ...d, date1: value ? value.split('T')[0] : "" }));
                }
                if (field === "refCheque") {
                    setCodePayementCheque(value);
                }
            }
            return updated;
        });
    };

    const [searchPay, setSearchPay] = useState("");
    const [listSearchPay, setListSearchPay] = useState([]);
    const [isSearchPay, setIsSearchPay] = useState(false);
    const [disableInputs, setDisableInputs] = useState(false);
    const [fileName, setFileName] = useState("");
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successAlertText, setSuccessAlertText] = useState();
    const [infoAlertText, setInfoAlertText] = useState();
    const [file, setFile] = useState([]);
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [amount, setAmount] = useState();
    const [selectedOption, setSelectedOption] = useState(null);
    const [data, setData] = useState({
        date1: '',
        city: '',
        date2: new Date().toISOString().split('T')[0], // Current date in 'YYYY-MM-DD' format
        reference: '',
        amount: '',
        message1: "",
        message2: "",
        amountWords: '',
        name: '',
        testMessage: '',
        bank: '',
        description:''
    });
    const handleCityChange = (event) => {
        setData({
            ...data,
            city: event.target.value, // Update the city value in the state
        });
    };


     const handleDescriptionChange = (event) => {
        setData({
            ...data,
            description: event.target.value, // Update the city value in the state
        });
    };
    const [payementSelectPlaceHolder, setPayemenSelectPlaceHolder] =
        useState("Choisir...");
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    useEffect(() => {
        const retrievedRow = JSON.parse(sessionStorage.getItem("wallet"));
        console.log(retrievedRow)
        if (retrievedRow) {
            const { firstName } = retrievedRow.userCreation || {};
            const { title } = retrievedRow.tier || {};

            setData((prevData) => ({
                ...prevData,
                message1: title,
                message2: title,
                name: firstName,
            }));
        }

        // const fetchBankAccounts = async () => {
        //     try {
        //         const response = await BanqueService.getAllBankAccounts(1);
        //         if (response.data?.Banque) {
        //             // Handle the case where "Banque" exists but is empty or contains data
        //         } else if (response.data?.success?.length > 0) {
        //             const bankDetails = response.data.success[0];
        //             setData((prevData) => ({
        //                 ...prevData,
        //                 reference: bankDetails?.rib,
        //                 bank: bankDetails?.name,
        //             }));
        //         }
        //     } catch (error) {
        //         console.error("Error fetching bank accounts:", error);
        //     }
        // };

        // fetchBankAccounts();
    }, []);
    const changeDatePayementCheque = (event) => {
        setDatePayementCheque(event.target.value.concat(":59"));
        setData({
            ...data,
            date1: event.target.value.split('T')[0], // Update the city value in the state
        });
    };
    const changeAmount = (event) => {
        setAmount(event.target.value);
        setData({
            ...data,
            amount: event.target.value, // Update the city value in the state
            amountWords: nombreEnTexte(event.target.value)
        });
    };

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const changeCodePayementCheque = (event) => {
        setCodePayementCheque(event.target.value);

    };
    const changeSearchPay = (event) => {
        setSearchPay(event.target.value);
    };

    const onUploadFileHandler = (e) => {
        if (e.target.files[0].size > 2097152) {
            setOpenInfoAlert(true);
            setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
        } else {
            setFileName(e.target.files[0].name);

            setFile(e.target.files[0]);
        }
    };

    const payerBill = (e) => {
        const url = window.location.pathname.split("/")[1];
        if (url === "chargerWallet") {
            if (!amount || amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Le montant est vide ");
            } else if (chequeLines.some(l => !l.refCheque || !l.dateEcheance)) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Veuillez remplir toutes les lignes de chèques (ref + date)");
            } else {
                let walletModel = {
                    idUser: getCurrentUserId(),
                    idBa: parseInt(localStorage.getItem("banqueAccount")),
                    idWallet: parseInt(sessionStorage.getItem("idWallet")),
                    typePayement: 2,
                    echanceDate: chequeLines[0].dateEcheance ? chequeLines[0].dateEcheance.concat(":59") : "",
                    codeCheque: chequeLines[0].refCheque,
                    ammountPayed: amount,
                    urlFile: "any",
                    cheques: chequeLines.map(l => ({
                        dateEcheance: l.dateEcheance ? l.dateEcheance.concat(":59") : "",
                        refCheque: l.refCheque,
                    })),
                };
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);
                    startLoading();
                    UploadAndDownloadService.uploadFile(
                        "/sales/uploadFileSelling/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                walletModel.urlFile = response.data.success;
                                TierAccountService.addWalletPayement(walletModel)
                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            //   toast.error("Error : il ya un probléme");
                                        } else {
                                            setOpenSuccessAlert(true);
                                            setSuccessAlertText("Enregistrement avec succées");
                                            setTimeout(() => {
                                                navigate(`/walletClient`);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        setOpenErrorAlert(true);
                                        setErrorAlertText("Erreur :  " + error);
                                    })


                            } else {
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                } else {
                    startLoading();
                    TierAccountService.addWalletPayement(walletModel)
                        .then((response) => {
                            console.log(response);
                            if (response.data["error"]) {
                            } else {
                                setOpenSuccessAlert(true);
                                setSuccessAlertText("Enregistrement avec succées");
                                setTimeout(() => {
                                    navigate(`/walletClient`);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                }
            }
        } else if (url === "chargerWalletFournisseur") {
            if (!amount || amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Le montant est vide ");
            } else if (chequeLines.some(l => !l.refCheque || !l.dateEcheance)) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Veuillez remplir toutes les lignes de chèques (ref + date)");
            } else {
                let walletModel = {
                    idUser: getCurrentUserId(),
                    idBa: parseInt(localStorage.getItem("banqueAccount")),
                    idWallet: parseInt(sessionStorage.getItem("idWallet")),
                    typePayement: 2,
                    emetteur: emetteurCheque,
                    ammountPayed: amount,
                    urlFile: "any",
                    cheques: chequeLines.map(l => ({
                        dateEcheance: l.dateEcheance ? l.dateEcheance.concat(":59") : "",
                        refCheque: l.refCheque,
                    })),
                };
                console.log("walletModel",JSON.stringify(walletModel))
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);
                    startLoading();
                    UploadAndDownloadService.uploadFile(
                        "/retail/uploadFile/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                walletModel.urlFile = response.data.success;
                                TierAccountService.addWalletPayementFournisseurMultiTraite(walletModel)
                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            //   toast.error("Error : il ya un probléme");
                                        } else {
                                            setOpenSuccessAlert(true);
                                            setSuccessAlertText("Enregistrement avec succées");
                                            setTimeout(() => {
                                                navigate(`/walletFournisseur`);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        setOpenErrorAlert(true);
                                        setErrorAlertText("Erreur :  " + error);
                                    })


                            } else {
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                } else {
                    startLoading();

                    TierAccountService.addWalletPayementFournisseurMultiTraite(walletModel)
                        .then((response) => {
                            console.log(response);
                            if (response.data["error"]) {
                                //   toast.error("Error : il ya un probléme");
                            } else {
                                setOpenSuccessAlert(true);
                                setSuccessAlertText("Enregistrement avec succées");
                                setTimeout(() => {
                                    navigate(`/walletFournisseur`);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        }).finally(() => {
                            stopLoading();
                        });
                }
            }
        }
    };
    const searchPayement = () => {
        startLoading();
        BankService.searchPayementByRef(getCurrentUserId(), 2, searchPay).then((response) => {

            let backendData = [{}];

            response.data.success.map((element) => {
                let elem = {
                    value: element["codeCheque"], label: element["codeCheque"] + "-" + element["emetteur"], customElements: {
                        amount: element["amountPayed"],
                        dateEcheance: UtilsFormule.formatDateInput(element["echeanceDate"]),
                        emetteur: element["emetteur"]
                    }
                };
                backendData.push(elem);
            })
            setListSearchPay(backendData)
            setIsSearchPay(true)
            console.log(response)
        }).catch((e) => {
            console.log(e)

        }).finally(() => {
            stopLoading();
        })

    }
    const handleSuccessClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSuccessAlert(false);
    };
    const onChangeSelectedCheque = (selectedOptionn) => {
        setSelectedOption();
        setPayemenSelectPlaceHolder(selectedOptionn.label);
        setAmount(selectedOptionn.customElements.amount);
        setCodePayementCheque(selectedOptionn.value);
        setDatePayementCheque(selectedOptionn.customElements.dateEcheance);
        setEmetteurCheque(selectedOptionn.customElements.emetteur);
        setDisableInputs(true);

    };
    return (
        <>
            <br />
            <div className="row">
                <div className="col-12">
                    <label>Charger le wallet par chèque / traite: </label>
                </div>
            </div>

            {/* Barre de recherche */}
            <div className="input-group mb-2">
                <div className="input-group-prepend" style={{ width: "95%" }}>
                    <input
                        value={searchPay}
                        onChange={changeSearchPay}
                        className="form-control"
                        placeholder="Chercher payement"
                        type="text"
                    />
                </div>
                <div className="input-group-append">
                    <button onClick={searchPayement} type="button" className="btn btn-dark">
                        <i className="fas fa-solid fa-arrow-down"></i>
                    </button>
                </div>
            </div>

            {isSearchPay && (
                <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOption}
                    onChange={onChangeSelectedCheque}
                    options={listSearchPay}
                    placeholder={payementSelectPlaceHolder}
                />
            )}

            <hr />

            {/* SECTION HAUT : Montant, Compte bancaire, Lieu de creation */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Montant :</label>
                    <input
                        type="number"
                        min="0"
                        step="0.1"
                        className="form-control"
                        placeholder="Montant"
                        name="amount"
                        value={amount}
                        onChange={changeAmount}
                        disabled={disableInputs}
                    />
                </div>
                <div className="col-md-4">
                    <label>Compte bancaire</label>
                    <ListBanquesToPayement type={1} />
                </div>
                <div className="col-md-4">
                    <label>Lieu de création</label>
                    <TextField
                        style={{ width: "100%" }}
                        variant="outlined"
                        value={data.city}
                        onChange={handleCityChange}
                        type="text"
                        size="small"
                    />
                </div>
            </div>

            {/* <div className="row mb-3">
                <div className="col-md-6">
                    <label>Description</label>
                    <TextField
                        style={{ width: "100%" }}
                        variant="outlined"
                        value={data.description}
                        onChange={handleDescriptionChange}
                        type="text"
                        size="small"
                    />
                </div>
                <div className="col-md-6">
                    <label htmlFor="exampleInputFile">Ajouter chèque (fichier)</label>
                    <div className="input-group">
                        <div className="custom-file">
                            <input
                                accept="application/pdf, .jpg, .jpeg, .png"
                                type="file"
                                className="custom-file-input"
                                id="exampleInputFile"
                                onChange={onUploadFileHandler}
                            />
                            <label className="custom-file-label" htmlFor="exampleInputFile">
                                {fileName || "Choisir un fichier"}
                            </label>
                        </div>
                    </div>
                </div>
            </div> */}

            <hr />

            {/* GENERATEUR DE CHEQUES */}
            <div className="row mb-2">
                <div className="col-12">
                    <label><strong>Générateur de chèques</strong></label>
                </div>
            </div>
            <div className="row mb-3 align-items-end">
                <div className="col-md-3">
                    <label>Nombre de chèques</label>
                    <input
                        type="number"
                        min="1"
                        className="form-control"
                        placeholder="Ex: 12"
                        value={nbCheques}
                        onChange={(e) => setNbCheques(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Date de début</label>
                    <input
                        type="date"
                        className="form-control"
                        value={dateDebut}
                        onChange={(e) => setDateDebut(e.target.value)}
                    />
                </div>
                <div className="col-md-4">
                    <label>Périodicité</label>
                    <select
                        className="form-control"
                        value={periodicite}
                        onChange={(e) => setPeriodicite(e.target.value)}
                    >
                        {PERIODICITES.map(p => (
                            <option key={p.value} value={p.value}>{p.label}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-2">
                    <button
                        type="button"
                        className="btn btn-dark w-100"
                        onClick={generateChequeLines}
                        disabled={!nbCheques || !dateDebut}
                    >
                        <i className="fas fa-magic"></i> Générer
                    </button>
                </div>
            </div>

            {/* TABLEAU : Date d'écheance + Ref cheque */}
            <div className="row mb-2">
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <label className="mb-0">
                        <strong>Lignes de chèques</strong>
                        {chequeLines.length > 0 && chequeLines[0].dateEcheance && (
                            <span className="badge badge-secondary ml-2">{chequeLines.length} chèque(s)</span>
                        )}
                    </label>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-dark"
                        onClick={addChequeLine}
                    >
                        <i className="fas fa-plus"></i> Ajouter une ligne
                    </button>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-12">
                    <table className="table table-bordered table-sm">
                        <thead className="thead-dark">
                            <tr>
                                <th style={{ width: "50px" }}>#</th>
                                <th>Date d&apos;échéance</th>
                                <th>Ref chèque</th>
                                <th style={{ width: "60px" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {chequeLines.map((line, index) => (
                                <tr key={index}>
                                    <td className="text-center align-middle">{index + 1}</td>
                                    <td>
                                        <TextField
                                            style={{ width: "100%" }}
                                            variant="outlined"
                                            value={line.dateEcheance}
                                            onChange={(e) => updateChequeLine(index, "dateEcheance", e.target.value)}
                                            type="datetime-local"
                                            InputLabelProps={{ shrink: true }}
                                            size="small"
                                            disabled={disableInputs}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Réf chèque"
                                            value={line.refCheque}
                                            onChange={(e) => updateChequeLine(index, "refCheque", e.target.value)}
                                            disabled={disableInputs}
                                        />
                                    </td>
                                    <td className="text-center align-middle">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => removeChequeLine(index)}
                                            title="Supprimer"
                                        >
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <PrintableK data={data} />
                    <button
                        type="submit"
                        onClick={payerBill}
                        className="btn my-1 btn-dark float-right"
                    >
                        Payer
                    </button>
                </div>
            </div>

            <Snackbar
                open={openSuccessAlert}
                autoHideDuration={2000}
                onClose={handleSuccessClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleSuccessClose} severity="success">
                    {successAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openInfoAlert}
                autoHideDuration={4000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleInfoClose} severity="info">
                    {infoAlertText}
                </Alert>
            </Snackbar>
        </>
    );


}
export default withLoader(ChargerWalletMultiCheque)